import React, { FC, useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { ProjectMedia } from 'src/api/Api';

interface EditCaptionDialogProps {
  open: boolean;
  onClose: () => void;
  mediaItem: ProjectMedia;
  onSave: (newCaption: string) => Promise<void>;
}

const EditCaptionDialog: FC<EditCaptionDialogProps> = ({ open, onClose, mediaItem, onSave }) => {
  const [caption, setCaption] = useState(mediaItem.caption || '');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setCaption(mediaItem.caption || '');
    }
  }, [open, mediaItem.caption]);

  const handleSave = async () => {
    setIsSaving(true);
    await onSave(caption);
    setIsSaving(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Caption</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Caption"
          type="text"
          fullWidth
          variant="outlined"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          multiline
          rows={4}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCaptionDialog;
